import { Button } from '@iwoca/orion';
import ReactModal from 'react-modal';

import { useCurrentPayLink } from '../../../Checkout/hooks/useCurrentPayLink';
import { useModal } from '../../../store/ModalProvider';
import {
  CapturedPaymentDrawdownStatus,
  useCapturedPaymentDrawdown,
} from '../../CapturedPaymentDrawdownProvider';
import {
  DecisionModalIcon,
  DecisionModalIconType,
} from '../DecisionModal/DecisionModalIcon';

export const CAPTURED_PAYMENT_MODAL_ID = 'capturedPaymentModal';

export const CapturedPaymentDrawdownModal = () => {
  const { isOpen, closeModal } = useModal(CAPTURED_PAYMENT_MODAL_ID);
  const { decisionState } = useCapturedPaymentDrawdown();
  const { payLink } = useCurrentPayLink();

  return (
    <ReactModal
      className="absolute left-1/2 top-1/2 flex min-h-[288px] w-full max-w-[301px] -translate-x-1/2 -translate-y-1/2 flex-col rounded-s border border-secondary-80 bg-white p-l shadow-black-m outline-none"
      overlayClassName="fixed z-[15] inset-0 bg-overlay-decision-modal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      {(() => {
        if (decisionState === CapturedPaymentDrawdownStatus.APPROVED) {
          return (
            <>
              <DecisionModalIcon type={DecisionModalIconType.APPROVAL} />

              <p className="mb-l text-center text-xl font-bold text-success-drk">
                Confirmed
              </p>
              <p className="mb-l text-center text-m font-reg text-structure-40">
                Redirecting to overview...
              </p>
            </>
          );
        }

        if (decisionState === CapturedPaymentDrawdownStatus.ACKNOWLEDGED) {
          return (
            <>
              <DecisionModalIcon type={DecisionModalIconType.LOADING} />

              <p className="mb-l text-center text-m font-reg text-structure-40">
                Sending {payLink?.seller_trading_name || 'loading...'}{' '}
                confirmation
              </p>
            </>
          );
        }

        if (decisionState === CapturedPaymentDrawdownStatus.ERROR) {
          return (
            <>
              <DecisionModalIcon type={DecisionModalIconType.ERROR} />

              <p className="mb-l text-center text-m font-reg text-structure-40">
                Unfortunately, we have not been able to process the payment.
              </p>

              <p className="mb-l text-center text-m font-reg text-structure-40">
                Please try again.
              </p>

              <Button className="mt-l" onClick={closeModal}>
                Close
              </Button>
            </>
          );
        }

        return (
          <>
            <DecisionModalIcon type={DecisionModalIconType.LOADING} />
            <div className="flex grow items-center justify-center">
              <p className="mb-l text-center text-m font-reg text-structure-40">
                Confirming your payment plan...
              </p>
            </div>
          </>
        );
      })()}
    </ReactModal>
  );
};
